<template>
  <el-row :gutter="20">
    <el-col :span="20" :offset="2">
      <div class="message_content">
        <div class="message_content_layout">
          <!--判断为空-->
          <div class="emtyData-center" v-if="list_data.length == 0">
            <emptyData></emptyData>
          </div>
          <div>
            <div class="message_content" v-if="list_data.length != 0">
              <el-button @click="AllRead()">全部已读</el-button>
              <div v-for="item in list_data" :key="item.index">
                <el-card shadow="hover">
                  <div
                    class="msg_warpper select-head"
                    @click="detailHandle(item)"
                  >
                    <div class="msg_icon">
                      <img
                        v-if="item.readFlag == 0"
                        src="../../../assets/images/message_select.png"
                        alt
                      />
                      <img
                        v-if="item.readFlag == 1"
                        src="../../../assets/images/message.png"
                        alt
                      />
                    </div>
                    <div class="msg_content">
                      <div class="msg">
                        <span class="msg_title">
                          <span
                            class="message msg_item"
                            :class="{ msg_title_read: isread(item.readFlag) }"
                            v-text="item.titile"
                          ></span>
                        </span>
                        <div class="msg_detail">
                          <span
                            class="content"
                            v-text="item.msgContent"
                            :class="{ msg_detail_read: isread(item.readFlag) }"
                          ></span>
                        </div>
                      </div>
                      <span class="msg_time">
                        <span class="create_time">
                          <i class="fa fa-clock-o" aria-hidden="true"></i>
                          <span v-text="item.sendTime"></span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <span class="unread_red" v-if="item.readFlag != 1"></span>
                </el-card>
              </div>
              <!--分页区-->
              <el-row :gutter="20" v-show="list_data != ''">
                <el-col :span="6" :offset="10">
                  <el-pagination
                    @current-change="currentPageChange"
                    :page-size="pageList.size"
                    :current-page="pageList.current"
                    layout="total, prev, pager, next"
                    :total="pageList.total"
                  ></el-pagination>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import emptyData from "@/components/common/emptyData";
import util from "@/utils";
import { getMessageList, messageUpdate, messageAllRead } from "@/api/index.js";
export default {
  data() {
    return {
      list_data: "",
      pageList: "",
      status: "",
      pageSize: 5,
      pageNo: 1,
    };
  },
  components: {
    emptyData: emptyData,
  },
  methods: {
    handleClick(tab, event) {
      const that = this;
    },
    currentPageChange(val) {
      var that = this;
      that.pageNo = val;
      that.readyList();
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 初次获取数据
     */
    readyList() {
      const that = this;
      const params = {
        pageNo: that.pageNo,
        pageSize: that.pageSize,
        userId: util.getStore("user_id"),
      };
      getMessageList(params).then(that.readyHandle);
    },
    readyHandle(res) {
      const that = this;
      if (res.success) {
        that.list_data = res.result.data.records;
        that.pageList = res.result.data;
        //设置导航的消息未读状态
        let isRead = res.result.unReadNumber;
        this.$store.dispatch("setMsgRead", isRead);
      } else {
        that.$message({
          showClose: true,
          message: res.message,
          type: "error",
        });
      }
    },
    isread(status) {
      if (status == 1) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 阅读是否处理
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    async detailHandle(item) {
      try {
        if (item.readFlag == 1) {
          return;
        }
        const params = {
          anntId: item.anntId,
          userId: util.getStore("user_id"),
        };
        let res = await messageUpdate(params);
        if (res.success) {
          this.readyList();
        }
      } catch (error) {
        console.log(errors);
      }
    },
    /**
     * 消息全部已读
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    async AllRead() {
      const params = {
        userId: util.getStore("user_id"),
      };
      let res = await messageAllRead(params);
      if (res.success) {
        this.$message({
          showClose: true,
          message: res.message,
          type: "success",
        });
        this.readyList();
      }
    },
  },
  mounted() {
    this.readyList();
  },
};
</script>
<style lang="scss" scoped>
.message_content .card-header-custom span {
  line-height: 30px;
}

.message_content .el-button {
  width: 100px;
}

.message_content .el-card {
  margin-top: 10px;
  font-size: 14px;
  min-height: 4em;
  position: relative;
}

.message_content .footer {
  padding: 18px 20px;
}

.message_content .el-tabs--border-card > .el-tabs__content {
  height: 0;
  padding: 0;
  margin: 0;
}

.message_content .create_time {
  font-size: 11px;
  color: #999;
}

.message_content {
  line-height: 1.25rem;
  position: relative;
  /* padding: 24px 12px 18px 24px; */
}

.message_content .main-content .content {
  word-break: break-all;
}

.read_status {
  color: #f39c12;
}

.msg_detail_read {
  color: #a69e9e;
}

.msg_title_read {
  color: #a69e9e;
}

.message_content .msg_warpper {
  display: flex;
  padding: 20px;
}

.message_content .msg_warpper .msg_content {
  text-align: left;
}

.message_content .msg_warpper .msg_icon {
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.message_content .unread_red {
  width: 15px;
  height: 15px;
  background: #fe646a;
  display: block;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: 15px;
}

.message_content .msg_warpper .msg_title {
  font-size: 16px;
  font-weight: bold;
  color: #f39c12;
}

.message_content .msg_warpper .msg_detail {
  margin: 10px 0;
}

.message_content .msg_warpper .msg_detail .notice_detail {
  font-size: 10px;
  color: #f39c12;
}

.message_content .msg_warpper .msg_icon img {
  width: 48px;
}
/**
	*把user中样式覆盖
	*/
.message_content .el-card__body {
  padding: 20px !important;
}
/deep/.el-button:focus{
      border:1px solid #FC701A;
      color: #FC701A
    }
</style>
